<div class="top-image w-100"></div>
<div class="paywall-container">
  <!-- <div class="header d-flex align-items-center justify-content-space-between">
    <div class="header-text d-flex flex-column justify-content-space-between h-100">
      <div class="header-title">{{discountTitle}} discount</div>
      <div>is reserved for:</div>
    </div>
    <div class="d-flex align-items-center gap-15">
      <div class="header-timer fw-semibold">{{ timer }}</div>
      <button mat-flat-button color="primary" (click)="topButtonClicked()">{{purchaseButtonTitle}}</button>
    </div>
  </div> -->

  <!-- <div class="d-flex mt-20 justify-content-center w-100">
    <div class="d-flex flex-column justify-content-center align-items-center p-15 comparison light-brown-color border-radius">
      <div class="top-title d-flex w-100 mb-10 bg-white border-radius p-15">
        <div class="top-label">Now</div>
        <div class="top-label main-color">With FemSecret</div>
      </div>
      <div class="top-image-square-container">
        <div class="image" [class]="topImageClassName"></div>
      </div>
    </div>
  </div> -->

  <h1 class="display-6 mt-30">Your Personalized Pleasure Journey Is Ready</h1>

  <h1 class="display-6 mt-30">Select your plan:</h1>

  <div 
  class="gift-box col-12 col-lg-6 border-radius d-flex align-items-center bg-green-color" 
  (click)="payButtonClicked()"
  >
    <div class="gift-icon"></div>
    <div *ngIf="placement === 'quiz_discount'" class="gift-label">Get your personal plan with a <span class="crossed greyed">{{initialDiscountTitle}}</span> {{discountTitle}} discount</div>
    <div *ngIf="placement === 'quiz'" class="gift-label">
      <div>{{discountTitle}} <span class="fw-normal">discount is reserved for:</span></div>
      <div>{{ timer }}</div>
    </div>
  </div>

  <div class="col-12 mt-25" #topCheckout>
    <app-checkout 
      #checkout 
      [(selectedProduct)]="selectedProduct"
      [placement]="placement"
      [email]="email" 
      [name]="name"
      [isDisclaimerShown]="false"
      [stripeCustomerId]="stripeCustomerId"
      [insufficientFundsAction]="getInsufficientFundsAction()"
      (canceledPurchase)="onPurchaseCanceled()"
      (purchaseButtonTitle)="handlePurchaseButtonTitle($event)"
      (discountTitle)="handleDiscountTitle($event)">
    </app-checkout>
  </div>

  <div class="mt-20 d-flex flex-column align-items-center">
    <div class="payment-promo">Safe, secure and easy way to pay</div>
    <div class="options-logos"></div>
  </div>

  <h1 class="display-6 mt-10">We've prepared a few audio samples for you</h1>
  <div class="row align-items-center w-100">
      <div class="col-12 light-brown-color border-radius p-25 d-flex flex-column gap-15">
          <h5 class="display-6">Just Hit <span class="ri-play-fill main-color"></span> to Try</h5>
          <app-audio-track *ngFor="let track of tracks" #audioTrackRef (onPlayed)="onPlay($event)" [data]="track"></app-audio-track>
      </div>
  </div>


  <div class="row align-items-center mt-30">
      <h2 class="display-6">What you get with FemSecret?</h2>
      <div class="mt-15 ps-20 text-list">
          <div class="section-title">Pleasure discovery:</div> 
          <div>Whether its hard & kinky or soft & sensual. At femtasy you'll find exactly what turns you on.</div>
          <div class="section-title">Unlimited access:</div> 
          <div>Enjoy over 5,000 stories and raw sounds, crafted specifically for women’s desires.</div>
          <div class="section-title">Investing in Your Health:</div>
          <div>Regular self-sex contributes to more relaxation & well-being. Find out for yourself!</div>
          <div class="section-title">Self love ritual:</div> 
          <div>Start your path to more self-love with words of affirmations for body & soul.</div>
      </div>
        <!-- <h1 class="display-6" [innerHTML]="title"></h1>
        <div class="lead">Save hours and get your eyes some rest, in your spare time</div> -->
    <!-- <div class="col-lg-5 d-flex justify-content-center mt-20 mb-20">
      <img class="top-image" src="assets/img/top2.png">
    </div> -->
  </div>
  
  <!-- <div class="row mt-30">
      <h1 class="display-6">The world’s first mobile app <span class="main-color">built for listening with users in mind</span></h1>
  </div>
  <div class="row align-items-center mt-20">
      <div class="col-lg-6 col-sm-12 mt-20">
          <div class="lead">What you get with FemSecret?</div>
      </div>
  </div> -->

  <div class="row mt-30">
      <h1 class="display-6">We are ready to answer you questions</h1>
  </div>
  <div class="col-md-12 mt-25">
      <mat-accordion class="tagus-basic-expansion mb-20">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
              <mat-panel-title>
                Why do I need FemSecret?
              </mat-panel-title>
          </mat-expansion-panel-header>
          <p>Because it’s a safe, supportive space that nurtures women’s sexual health and well-being, helping you explore your desires with immersive erotic audio. Our stories and raw sex sounds, created alongside sex educators, highlight genuine pleasure, communication, and self-discovery—empowering you to embrace your sexuality with confidence.</p>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
              Who we are?
            </mat-panel-title>
        </mat-expansion-panel-header>
        <p>We're a women-led team of producers and engineers who are obsessed with making the very best erotic audio for women. We partner with an incredible network of top-tier narrators and writers to guarantee quality of every single story.</p>
    </mat-expansion-panel>
          <mat-expansion-panel>
              <mat-expansion-panel-header>
                  <mat-panel-title>
                    How often is there new content?
                  </mat-panel-title>
              </mat-expansion-panel-header>
              <p>New content is released each week and with thousands of stories to explore, there’s plenty to discover.</p>
            </mat-expansion-panel>
          <mat-expansion-panel>
              <mat-expansion-panel-header>
                  <mat-panel-title>
                    How do I get access to the app?
                  </mat-panel-title>
              </mat-expansion-panel-header>
              <p>After you enter your email address, you will receive an email with a temporary password and link to access the app. Simply follow the link and sign in using your email and password.</p>
            </mat-expansion-panel>
          <mat-expansion-panel>
              <mat-expansion-panel-header>
                  <mat-panel-title>
                    How do I cancel my account?
                  </mat-panel-title>
              </mat-expansion-panel-header>
              <p>It's easy! Just log into your account here, go to "Settings", and click the Cancel button.</p>
            </mat-expansion-panel>
      </mat-accordion>
  </div>

  <h1 class="display-6 mt-30">Don’t Just Take Our Word for It</h1>

  <div class="d-flex flex-wrap justify-content-center w-100 mt-20 gap-10">
    <app-user-review *ngFor="let review of reviews" [data]="review"></app-user-review>
  </div>

  <button mat-flat-button color="tagus" class="pay-button pulsing" (click)="payButtonClicked()">{{purchaseButtonTitle}}</button>

  <!-- <h1 class="display-6 mt-20">Try <span class="main-color">FemSecret Premium</span> with introductory discount</h1>
  <div class="subscription-info">
    <div class="subscription-text">Enjoy unlimited access for selected period. Love it and keep investing in yourself, or simply cancel before the period ends so you won’t be charged repeatedly.</div>
  </div>

  <button mat-flat-button color="tagus" class="pay-button" (click)="payButtonClicked()">{{purchaseButtonTitle}}</button> -->

  <h1 class="display-6 mt-30"><span class="main-color">1,000,000+ Women</span></h1>
  <div class="d-flex flex-wrap justify-content-center w-100 mt-20 gap-15">
    <div class="stat d-flex align-items-center">
      <div class="stats-icon"></div>
      <div class="d-flex flex-column">
        <div class="stats-title"><span class="highlight">1M+</span></div>
        <div class="stats-text">Trust FemSecret to explore their desires.</div>
      </div>
    </div>
    <!-- <div class="stat d-flex align-items-center">
      <div class="stats-icon"></div>
      <div class="d-flex flex-column">
        <div class="stats-title"><span class="highlight">4.8</span> Stars</div>
        <div class="stats-text">Average ratings on App Store</div>
      </div>
    </div> -->
    <div class="stat d-flex align-items-center">
      <div class="stats-icon"></div>
      <div class="d-flex flex-column">
        <div class="stats-title"><span class="highlight">91%</span> of FemSecret members</div>
        <div class="stats-text">Reported an improvement in their intimate well-being.*</div>
      </div>
    </div>
  </div>

  <h1 class="display-6 mt-30">Select your plan:</h1>

  <div class="col-12 mt-15">
    <app-checkout
      #checkout 
      [(selectedProduct)]="selectedProduct"
      [placement]="placement"
      [email]="email" 
      [name]="name"
      [stripeCustomerId]="stripeCustomerId"
      [isDisclaimerShown]="false"
      [insufficientFundsAction]="getInsufficientFundsAction()"
      (canceledPurchase)="onPurchaseCanceled()"
      (purchaseButtonTitle)="handlePurchaseButtonTitle($event)"
      (discountTitle)="handleDiscountTitle($event)">
    </app-checkout>
  </div>

  <div class="hint mt-20 fs-14">*Based on survey data from FemSecret users</div>

  <div class="gray-color fs-12 mt-20" *ngIf="selectedProduct">We’ve automatically applied discount to your first subscription price. You will be charged ${{selectedProduct.introductoryPriceUsd}}. Please note that your subscription will be automatically renewed at full price of ${{selectedProduct.recurringPriceUsd}} at the end of chosen subscription term. Terms and Conditions apply. If you want to manage your subscription, you may do so via your personal account.</div>

  <div class="gray-color mt-20 mb-30 fs-12"><a target="_blank" href="https://www.getpeech.com/terms">Terms & Conditions</a> and <a target="_blank" href="https://www.getpeech.com/privacy">Privacy Policy</a></div>
</div>
